import { useI18n } from '../i18n/useI18n';

const limits = [
  'limits.item.ai',
  'limits.item.screen',
  'limits.item.expert',
  'limits.item.legal',
];

export function LimitsSection() {
  const { t } = useI18n();

  return (
    <section className="section caution-section">
      <div className="section-heading">
        <p className="eyebrow">{t('limits.eyebrow')}</p>
        <h2>{t('limits.title')}</h2>
        <p>{t('limits.text')}</p>
      </div>
      <ul className="plain-list">
        {limits.map((item) => (
          <li key={item}>{t(item)}</li>
        ))}
      </ul>
      <p className="section-note">{t('limits.note')}</p>
    </section>
  );
}
